export default function AnnouncementModalCtrl(
  $uibModalInstance,
  Restangular,
  announcement,
  notification
) {
  'ngInject';

  const controller = this;
  controller.announcement = announcement;
  controller.notification = notification;
  controller.created = null;

  // timezone fix for announcements
  let postDate = controller.announcement.posted;
  postDate = new Date(`${postDate.substring(0, 19)}+00:00`);
  const offset = postDate.getTimezoneOffset() * 60 * 1000;
  postDate = new Date(postDate.getTime() + offset);
  controller.created = postDate;
}
